<template>
  <DatatableReportV3
    title="Permits"
    download-url="/reports/permits"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        columns: [
          { data: "status", title: "Permit Status", searchable: false },
          {
            data: "created_date",
            title: "Created Date",
            searchable: false
          },
          { data: "job" },
          { data: "location_name", title: "Location Name" },
          { data: "city" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "technician", filterName: "technician_id" },
          { data: "inspection_date", title: "Inspection Date" }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
